import { Component, OnInit } from '@angular/core';
import { InmuebleResponse } from 'src/app/models/InmueblesResponse';
import { ConfiguracionModel } from 'src/app/models/configuracion.model';
import { ConfiguracionService } from 'src/app/services/configuracion.service';


@Component({
    selector: 'app-whatsapp',
    templateUrl: './whatsapp.component.html',
    styleUrls: ['./whatsapp.component.css'],
    standalone: false
})
export class WhatsappComponent implements OnInit {
  configuracion:ConfiguracionModel;
  response:InmuebleResponse;
  respuesta:any;
  detalle:number;
  descripcion:string;
  botonOcultar: boolean;
  constructor(private configuracionService: ConfiguracionService) {

    this.configuracionService.consultarConfiguracion("whatsapp").subscribe( data => {
        
      if (data.configuracion != null) {
        this.configuracion = data.configuracion;
        
      } 
      if (data.respuesta.detalle==1) {
        this.botonOcultar=true;
      }else if(data.respuesta.detalle==0){
        this.botonOcultar=false;
      }
     
    
    })
   }
  

  ngOnInit() {
  }



}

